/**
 *
 * Functionality service module
 * Allow to access some functionalities features without to execute them.
 *
 * For example to get results of a search with no action on app :
 * ```javascript
 *
 * geoApp.getFunctionalityById('xxx').getService().executeSearch({
 *  filters:[{
 *    attribute:'nom_dept',
 *    value:'Creuse'
 *  }]
 * }).subscribe(function(results){
 *    console.log('results of search : ',results);
 * });
 *
 * ```
 *
 * @module geo/functionalities/services
 * @preferred
 * @since v2.1.0
 */

/**
 * @preferred
 */
import {Service} from '../../services';
import {FunctionalityOptions} from '../../types/functionality';

/**
 *
 * Service are used to access acf services. It's low level API.
 *
 */
export abstract class FunctionalityService<F extends FunctionalityOptions,
                                                     S extends Service> {
  /**
   * Functionality object use to call service
   *
   * @internal
   */
  protected abstract functionality: F;


  /**
   * parent generic service
   *
   * @internal
   */
  protected abstract parentService: S;
}